import { render } from "./resumeDetail.vue?vue&type=template&id=4105040e&scoped=true"
import script from "./resumeDetail.vue?vue&type=script&lang=js"
export * from "./resumeDetail.vue?vue&type=script&lang=js"

import "./resumeDetail.vue?vue&type=style&index=0&id=4105040e&lang=less&scoped=true"

import exportComponent from "/Users/yiduolanghua/Desktop/edu/visitor-h5-jy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4105040e"]])

export default __exports__